<template>
  <a class="d-block" @click="clickHandler" :href="href" target="_blank">
    <v-list-item class="pa-0" dense>
      <AttachmentThumbnail
        :file-type-extension="attachment.file_type_extension || 'FILE'"
        :thumbnail-url="thumbnailUrlIfSupported"
      ></AttachmentThumbnail>
      <AttachmentListItemContent
        :text="attachment.name"
      ></AttachmentListItemContent>
      <v-icon style="margin-right: 8px" @click.stop="handleDownload">{{
        mdiDownload
      }}</v-icon>
    </v-list-item>
  </a>
</template>

<script lang="ts">
import { computed, defineComponent, inject, PropType } from "vue"
import { Attachment, AttachmentTypeEnum } from "suus-api"
import AttachmentListItemContent from "./AttachmentListItemContent.vue"
import AttachmentThumbnail from "features/attachments/AttachmentThumbnail.vue"
import { LightboxService } from "features/gallery/lightbox/lightbox.service"
import { mdiDownload } from "@mdi/js"
import { download } from "app/util/download.helper"
import { VIcon } from "vuetify/lib/components"
import { isMimeTypeSupported } from "app/modules/core/supported-image-formats"

export default defineComponent({
  name: "AttachmentsListItem",
  components: { AttachmentThumbnail, AttachmentListItemContent, VIcon },
  props: {
    attachment: {
      type: Object as PropType<Attachment>,
      required: true,
    },
  },
  setup(props) {
    const attachment = computed(() => props.attachment)

    const href = computed(() =>
      isSupportedImage.value ? undefined : attachment.value.links.download_url
    )

    const lightboxService: LightboxService = inject("lightboxService")
    const clickHandler = computed(() => {
      if (isSupportedImage.value) {
        return () =>
          lightboxService.openLightbox(
            attachment.value.links.original_url ??
              attachment.value.links.download_url
          )
      }
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return () => {}
    })

    const handleDownload = () => {
      download(
        attachment.value.links.original_url,
        attachment.value.name ?? "Anhang"
      )
    }

    const isSupportedImage = computed(() =>
      isMimeTypeSupported(
        attachment.value.content_type ?? attachment.value.type
      )
    )
    const thumbnailUrlIfSupported = computed(() => {
      if (isSupportedImage.value) {
        return attachment.value.links.icon_url
      }
      return undefined
    })

    return {
      href,
      clickHandler,
      mdiDownload,
      handleDownload,
      thumbnailUrlIfSupported,
    }
  },
})
</script>

<style scoped></style>
